import React from 'react';
import './slots.scss';

const Slots = props => {
  const { slots, title, onSlotSelection, selectedSlot, type } = props;
  let opSlots = slots;
  if (type === 'day') {
    if (!selectedSlot) {
      onSlotSelection({ ...opSlots[0], type });
    }
  } else if (type === 'time') {
    opSlots = opSlots.map(s => {
      return {
        ...s,
        now: s.slot.toLowerCase() === 'now',
        name: s.slot,
      };
    });
  }

  const _getSlotClasses = slot => {
    const cssClasses = ['desktop-slots--slot', type];
    if (
      slot.deliverySlotId === selectedSlot?.deliverySlotId &&
      slot.slot === selectedSlot.slot
    )
      cssClasses.push('active');
    if (type === 'time' && !slot.available) cssClasses.push('disabled');
    return cssClasses.join(' ');
  };

  const _onSlotSelection = s => {
    onSlotSelection({ ...s, type });
  };

  return (
    <div className="desktop-slots">
      <div className="desktop-slots--title">{title}</div>
      <div className="desktop-slots--list">
        {opSlots.map((slot, index) => {
          return (
            <div
              className={_getSlotClasses(slot)}
              key={slot.deliverySlotId + slot.name}
              onClick={() => _onSlotSelection(slot)}
            >
              {slot.name}
              {slot.date && (
                <span className="desktop-slots--date">&nbsp;{slot.date} </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Slots;
